import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../core/models/generic-models';
import { IValidateGovIdPassortRequest, IValidateGovIdPassortResponse } from '../models/validate-gov-id-passport.model';
import {
  loadValidateGovIdPassports,
  loadValidateGovIdPassportsSuccess,
  loadValidateGovIdPassportsFailure,
  clearValidateGovIdPassportsFailure
} from '../actions/validate-gov-id-passport.actions';

export const validateGovIdPassportFeatureKey = 'validateGovIdPassport';

export interface ValidateGovIdPassportState {
  isLoading: boolean;
  validateGovIdPassportRequest: IValidateGovIdPassortRequest;
  validateGovIdPassportResponse: IValidateGovIdPassortResponse;
  validateGovIdPassportFailure: IGenericError<ErrorResponse>;
}

export const initialState: ValidateGovIdPassportState = {
  isLoading: false,
  validateGovIdPassportRequest: undefined,
  validateGovIdPassportResponse: undefined,
  validateGovIdPassportFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadValidateGovIdPassports, (state, action) => ({
    ...state,
    validateGovIdPassportRequest: action.request,
    isLoading: true
  })),

  on(loadValidateGovIdPassportsSuccess, (state, action) => ({
    ...state,
    validateGovIdPassportResponse: action.response,
    isLoading: false
  })),

  on(loadValidateGovIdPassportsFailure, (state, action) => ({
    ...state,
    validateGovIdPassportFailure: action.error,
    isLoading: false
  })),

  on(clearValidateGovIdPassportsFailure, (state, action) => ({
    ...state,
    validateGovIdPassportFailure: undefined
  }))
);

export const getValidGovIdPassportIsLoading = (state: ValidateGovIdPassportState) => state.isLoading;
export const getValidGovIdPassportRequest = (state: ValidateGovIdPassportState) => state.validateGovIdPassportRequest;
export const getValidGovIdPassportResponse = (state: ValidateGovIdPassportState) => state.validateGovIdPassportResponse;
export const getValidGovIdPassportFailure = (state: ValidateGovIdPassportState) => state.validateGovIdPassportFailure;
